import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import TextUtils from "../utils/TextUtils";
import auth from "../api/auth";
import stripe_api from "../api/protected/memberships"
import GenericDialog from "../components/GenericDialog";
import TeamsCardContainer from "../components/dashboard/TeamsCardContainer";
import SweetDreamsCard from "../components/dashboard/SweetDreamsCard";
import TasksCard from "../components/dashboard/TasksCard";
import ROICard from "../components/dashboard/ROICard";
import InfoRightPopUp from "../components/InfoRightPopUp";
import profile_api from "../api/protected/profile";
import AccreditationPopup from "../components/AccreditationPopup";
import dashboard_api from "../api/protected/dashboard"
import VerifyEmailPopup from "../components/VerifyEmailPopup";
import kapi from "../api/kratos";
import affiliate_reg_api from "../api/protected/registerAffiliate"


const Dashboard = () => {


    const navigate = useNavigate()
    const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
    const [showPaymentAccreditationPopup, setShowPaymentAccreditationPopup] = useState(false);
    const [showAccreditationPopup, setShowAccreditationPopup] = useState(false);
    const [enquiryTier, setEnquiryTier] = useState("")
    const [awaitingAccreditation, setAwaitingAccreditation] = useState(false);
    const [alreadyVerifiedAccreditation, setAlreadyVerifiedAccreditation] = useState(false)

    const [requiresStripe, setRequiresStripe] = useState(false);
    const [accessTokenSubscription, setAccessTokenSubscription] = useState(0); // Set 0 as default since that is Bronze

    const [subscriptionHandled, setSubscriptionHandled] = useState(false);

    const [subscription, setSubscription] = useState(null);

    const [comingFromRegistration, setComingFromRegistration] = useState(() => {
        return localStorage.getItem("comingFromRegistration") === "true";
    });


    const [forceCloseAccreditation, setForceCloseAccreditation] = useState(() => {
        return localStorage.getItem("forceCloseAccreditation") === "true";
    })

    const buttons = [
        {"id": 1, "text": "Confirm and Proceed to Payment"},
        {"id": 2, "text": "Return to plan options"}
    ];

    const autoGetSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription.type);
        }).catch(() => {});
    };

    useEffect(() => {
        autoGetSubscription();
    }, []);

    useEffect(() => {
        const run = async () => {
            const sub = await profile_api.getSubscription();

            if (comingFromRegistration) {
                const affiliateToken = localStorage.getItem("affiliateToken");

                // Always try affiliate registration if token exists
                if (affiliateToken) {
                    affiliate_reg_api
                        .registerAffiliateCookie(affiliateToken)
                        .then(() => console.log("Affiliate registration recorded"))
                        .catch((err) => console.error("Failed to register affiliate cookie", err));
                }

                // If Stripe is present, handle tier
                if (sub.data.stripe) {
                    const membership = sub.data.stripe_membership;
                    const tier =
                        membership === 1 ? "silver" : membership === 2 ? "gold" : null;

                    if (tier) {
                        setEnquiryTier(tier);
                        try {
                            const accResp = await profile_api.getAccreditation();
                            const isPreVerified = accResp.data?.accreditation?.verified === 1;
                            if (isPreVerified) {
                                handleAccreditationDialogResult("1", tier);
                            } else {
                                setShowPaymentAccreditationPopup(true);
                            }
                        } catch {
                            setShowPaymentAccreditationPopup(true);
                        }
                    }
                }

                // Cleanup after registration flow
                setComingFromRegistration(false);
                localStorage.removeItem("comingFromRegistration");
                localStorage.removeItem("affiliateToken");
                return; // stop here -> skip email validation
            }

            // Normal flow -> validate email
            const res = await dashboard_api.getValidateEmail();
            if (res.data !== 1) {
                navigate("/verify?unverified=true");
            } else {
                setShowVerifyEmailPopup(false);
            }
        };

        run();
    }, []);




    useEffect(() => {
        const runPendingVerification = async () => {
            const flowId = localStorage.getItem("pendingVerifyFlow");
            if (!flowId) return;

            try {
                const hasSession = await auth.hasSession();
                if (!hasSession) return; // user will be kicked to logout anyway by your other effect

                // 1) Re-hydrate the verification flow from Kratos
                const { data: flowData } = await kapi.get_verification(flowId);

                // 2) Send it to your backend (same shape as /verify page)
                const resp = await dashboard_api.putValidateEmail(flowData);

                const ok =
                    resp?.data?.ok ??
                    resp?.data?.success ??
                    (resp?.status === 200 && typeof resp?.data === "object");

                if (ok) {
                    // refresh UI state
                    const r = await dashboard_api.getValidateEmail();
                    const isAlreadyVerified = r.data === 1;
                    setShowVerifyEmailPopup(!isAlreadyVerified);
                    // (optional) toast/snackbar here saying “Email verified”
                } else {
                    // (optional) toast/snackbar here saying “Verification failed”
                    console.warn("Email verification did not return ok/success");
                }
            } catch (err) {
                // Handle expired/invalid flow gracefully; always clear the key.
                const status = err?.response?.status;
                if (status === 410 || status === 404 || status === 400) {
                    console.warn("Pending verification link expired/invalid.");
                } else {
                    console.error("Pending verification failed:", err);
                }
            } finally {
                localStorage.removeItem("pendingVerifyFlow");
            }
        };

        runPendingVerification();
    }, []);


    const popUpText = () => {
       return (
           <div className="accreditation-popup-text">
               <div className="accreditation-popup-text-paragraph">
                   You are just about to pay for the {enquiryTier && TextUtils.toTitleCase(enquiryTier)} plan.
               </div>
               <div className="accreditation-popup-text-paragraph">
                   In order to be able to access the full functionality, you must be an accredited team coach, and
                   you will need to upload details of your team coach training and/or accreditation. This is to ensure
                   that only trained users who understand team coaching and the necessity for a psychologically safe
                   environment for debriefing diagnostics are provided access.
               </div>
               <div className="accreditation-popup-text-paragraph">
                   We accept suitably qualified Team Coaches from the systemic programmes listed below:
                   <ul>
                       <li>CMI Team Coach - Foundation/Practitioner/Senior Practitioner</li>
                       <li>GTCI Team Coach - Foundation/Practitioner/Senior Practitioner (either PERILL or STC
                           streams)</li>
                       <li>AOEC / Renewal Associates Systemic Team Coaching Certificate or Diploma</li>
                       <li>Henley Business School:Professional Certificate in Team and Systemic Coaching</li>
                       <li>ORSC</li>
                       <li>Ruth Wageman’s 6 Conditions</li>
                       <li>Team Coach International</li>
                       <li>Smurfit Business School (Dublin)</li>
                       <li>High Performance Team Coaching System (Carr)</li>
                       <li>Another EMCC & ICF accredited systemic team coaching programme at the same level</li>
                   </ul>
               </div>
               <div className="accreditation-popup-text-paragraph">
                   You will now be directed to the payment screen and you will be charged for your annual
                   subscription to the {enquiryTier && TextUtils.toTitleCase(enquiryTier)} plan. Following successful payment,
                   you will be asked to upload details of your accreditation. Approval of accreditation will be
                   within 7 working days. You will not be able to access the full features of
                   the {enquiryTier && TextUtils.toTitleCase(enquiryTier)} plan until you have uploaded these documents
                   and they have been verified, even if your payment has been taken.
               </div>
           </div>
       )
    }

    const handleAccreditationDialogResult = (res, overrideTier) => {
        const activeTier = overrideTier || enquiryTier;
        if (!res || !activeTier) return;

        if (res === "1") {
            switch (activeTier) {
                case "silver":
                    stripe_api.CreateCheckoutSession("silver", "/dashboard");
                    break;
                case "gold":
                    stripe_api.CreateCheckoutSession("gold", "/dashboard");
                    break;
            }
        } else if (res === "2") {
            navigate("/pricing-plans");
        }
        setShowPaymentAccreditationPopup(false);
    };


    useEffect(() => {
        auth.hasSession().then(async (session) => {
            if (!session) {
                window.location.assign("/logout");
                return;
            }
            // Membership Enquiry after login/register
            let tier = stripe_api.ExecuteEnquiry();
            if (!tier) {
                // Check subscription for force to stripe if access_code requests and they havent tried to initiate
                // a payment flow
                GetAccreditation()
                GetSubscription();
                return
            }
            setEnquiryTier(tier)


            // Check accreditation status
            const acc = await profile_api.getAccreditation();
            const data = acc.data?.accreditation;

            if (data?.verified === 1) {
                // auto-trigger the same flow as clicking option 1
                if (tier === "silver") {
                    stripe_api.CreateCheckoutSession("silver", "/dashboard");
                } else if (tier === "gold") {
                    stripe_api.CreateCheckoutSession("gold", "/dashboard");
                }
            } else {
                // fallback -> show dialog as normal
                setShowPaymentAccreditationPopup(true);
            }
        });
    }, [])


    const GetAccreditation = () => {
        profile_api.getAccreditation()
            .then((response) => {
                const accreditationData = response.data?.accreditation;

                if (
                    accreditationData &&
                    accreditationData.type &&
                    accreditationData.verification_date === null &&
                    accreditationData.verified === 0
                ) {
                    setAwaitingAccreditation(true);
                } else if (accreditationData && accreditationData.verified === 1)
                {
                    setAlreadyVerifiedAccreditation(true)
                } else {
                    setAwaitingAccreditation(false);
                }

            })
            .catch((err) => {
                console.error("Error fetching accreditation:", err);
            });
    };


    const GetSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            // Force stripe flow
            if (response.data.stripe && response.data.stripe_membership) {
                let _tier
                if (response.data.stripe_membership === 1) _tier = 'silver'
                else if (response.data.stripe_membership === 2) _tier = 'gold'
                else navigate('/pricing-plans')
                setEnquiryTier(_tier)
                setShowPaymentAccreditationPopup(true)
            }
            // Accreditation Flow
            if (response.data.subscription.type === 0 && response.data.subscription.actual_subscription.type > 0) {
                setShowAccreditationPopup(true)
            }

        }).catch(() => {})
    }

    const handleAccreditationClose = () => {
        localStorage.setItem("forceCloseAccreditation", "true");
        setForceCloseAccreditation(true);
        setShowAccreditationPopup(false);
    };

    const handlePaymentDialogClose = () => {
        setShowPaymentAccreditationPopup(false)
    }


    return (
        <div className="dashboard-page-background-container">
            <div className="dashboard-page-container">
                <div className="dashboard-page-header">
                    <div className="page-header-title-container">
                        <div className="dashboard-page-title">Dashboard</div>
                        <InfoRightPopUp text={"The Dashboard gives you a simple way to view and manage " +
                            "your task list and latest team responses."}/>
                    </div>
                </div>
                {!(subscription < 1) ?
                    <ROICard/>
                : null}
                <TasksCard/>
                <TeamsCardContainer/>
                <SweetDreamsCard/>
            </div>
            {showPaymentAccreditationPopup && showPaymentAccreditationPopup && !alreadyVerifiedAccreditation ?
                <GenericDialog text={popUpText()} title={"Membership Accreditation"} buttons={buttons}
                               result={handleAccreditationDialogResult.bind(this)} wide={true} onClose={handlePaymentDialogClose}/>
                : null
            }
            {showVerifyEmailPopup && showVerifyEmailPopup ?
                <VerifyEmailPopup wide={false} /> : null }
            {showAccreditationPopup && !awaitingAccreditation && !forceCloseAccreditation  ? (
                <AccreditationPopup setShowPopup={handleAccreditationClose} />
            ) : null}

        </div>
    )
}

export default Dashboard
